export class PdfViewerPageMapper {
    static mapToPublicPdfViewerPage(pdfViewerPage) {
        return {
            id: pdfViewerPage.id,
            pageNumber: pdfViewerPage.pageNumber,
            renderState: pdfViewerPage.renderState,
            previewRenderState: pdfViewerPage.previewRenderState,
            getAnnotationHelper: () => pdfViewerPage.getAnnotationHelper(),
            getAnnotations: () => pdfViewerPage.getAnnotations(),
            didAnnotationsChange: () => pdfViewerPage.didAnnotationsChange(),
            enableAnnotations: () => pdfViewerPage.enableAnnotations(),
            disableAnnotations: () => pdfViewerPage.disableAnnotations()
        };
    }
}
//# sourceMappingURL=pdf-viewer-page-mapper.js.map